<template>
  <div class="date-tabs">
    <div
      @click="tabClick(index)"
      :class="[tabIndex === index ? 'sel' : '', 'tab']"
      v-for="(item, index) in data"
      :key="index"
    >
      {{ item }}
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
export default {
  name: "chart-date-tabs",
  props: {
    data: Array
  },
  setup(props, content) {
    const tabIndex = ref(0);
    const tabClick = (index) => {
      tabIndex.value = index;
      content.emit("tab-click", index);
    };
    return {
      tabClick,
      tabIndex
    };
  }
};
</script>
<style scoped lang="less">
.date-tabs {
  display: flex;
  height: 32px;
  padding: 4px;
  background-color: #f7f8fa;
  .tab {
    padding: 0 12px;
    color: #86909c;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }
  .sel {
    color: #1d2129;
    font-weight: 500;
    background: #e5e6eb;
    border-radius: 2px;
  }
  .tab:hover {
    background: #e5e6eb;
  }
}
</style>
